import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import { XStack } from '@my/ui'
import BrandAToZTabItem from './brand-a-to-z-tab-item'

export const BrandAToZTabs = ({
  letters,
  currentSelectedLetter,
  onPress,
}: {
  letters: string[]
  currentSelectedLetter?: string
  onPress: (string) => void
}) => {
  const [emblaRef] = useEmblaCarousel(
    {
      slidesToScroll: 1,
      containScroll: 'keepSnaps',
      skipSnaps: true,
      align: 'start',
      startIndex: letters.findIndex((letter) => letter === currentSelectedLetter),
    },
    [WheelGesturesPlugin()]
  )

  return (
    <div ref={emblaRef as any}>
      <XStack height="auto" style={{ backfaceVisibility: 'hidden' }}>
        {letters.map((letter) => {
          return (
            <XStack minWidth={0} flexGrow={0} flexShrink={0} flexBasis="auto" key={letter}>
              <BrandAToZTabItem
                letter={letter}
                currentSelectedLetter={currentSelectedLetter}
                onPress={() => onPress(letter)}
              />
            </XStack>
          )
        })}
      </XStack>
    </div>
  )
}
